import script from "./viewEditKontraktorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./viewEditKontraktorPage.vue?vue&type=script&setup=true&lang=js"

import "./viewEditKontraktorPage.vue?vue&type=style&index=0&id=e85fb852&lang=css"

const __exports__ = script;

export default __exports__